import React from 'react';
import styled from 'styled-components';
import { SVG } from '@engelvoelkersamericas/common-story-ui';
const { Chevron } = SVG;
export default function CustomChevron(props) {
  const { isDown, onClick, rotateTime = '.3s' } = props;
  return (
    <Container isDown={isDown} rotateTime={rotateTime} onClick={onClick}>
      <Chevron {...props} />
    </Container>
  );
}

const Container = styled.div`
  transition: transform ${({ rotateTime }) => rotateTime} ease-in-out;
  transform: rotate(${({ isDown }) => (isDown ? '0' : '-180deg')});
  cursor: pointer;
  svg {
    fill: red;
    width: 20px;
    height: 20px;
  }
`;
